import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import enTranslations from './locales/en.json';
import esTranslations from './locales/es.json';
import frTranslations from './locales/fr.json';
import itTranslations from './locales/it.json';
import deTranslations from './locales/de.json';
import nlTranslations from './locales/nl.json';
import ptTranslations from './locales/pt.json';

// Carregar idioma salvo no localStorage ou usar o padrão
const savedLanguage = localStorage.getItem('language') || 'pt';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translation: enTranslations
      },
      es: {
        translation: esTranslations
      },
      fr: {
        translation: frTranslations
      },
      it: {
        translation: itTranslations
      },
      de: {
        translation: deTranslations
      },
      nl: {
        translation: nlTranslations
      },
      pt: {
        translation: ptTranslations
      }
    },
    lng: savedLanguage,
    fallbackLng: 'pt',
    interpolation: {
      escapeValue: false
    }
  });

export default i18n; 